module.exports = __webpack_public_path__ + "img/ama_middle@3x.ef5e559e.png";